import * as React from 'react';
import { FormField, FormFieldProps } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { AllowedDataHandler, AllowedDataHandlerField } from '../../models';
import AllowedDataHandlerItem, { AllowedDataHndlrItem } from './allowedDataHandlerItem';
import { RemoveItemButton } from '../removeItemButton';
import { AddItemButton } from '../addItemButton';
import { InputError } from 'sos-common/js/components/InputError/InputError';
import { InputInfo } from 'sos-common/js/components/InputInfo/inputInfo';
import { shortuid } from 'sos-common/js/utils/guid';
import { getErrorMessageByFieldName } from '../../utilities/helpers';
export interface AllowedDataHandlersListProps extends FormFieldProps<AllowedDataHandler[]> {
  namePlaceholder: string;
  organisationPlaceholder: string;
  onChange(field: AllowedDataHandlerField): void;
  validationResults: ValidationResult[];
  hasHitSummary?:boolean;
}

export default class AllowedDataHandlersList extends React.Component<
  AllowedDataHandlersListProps,
  AllowedDataHandlerField
> {
  static defaultProps = {
    value: [{}]
  };

  constructor(props: any) {
    super(props);
    const { fieldName, value } = this.props;
    let _value = value === null ? [{}] : value;

    _value = _value.map(v => {
      return {
        ...v,
        FieldName: shortuid()
      } as AllowedDataHandler;
    });

    this.state = {
      fieldName,
      value: _value
    };
  }

  private get _errorMessage(): string | undefined {
    let { errorMessage } = this.state;
    if (!errorMessage && this.props.errorMessage) {
      errorMessage = this.props.errorMessage;
    }

    return errorMessage;
  }

  propogateChange = () => {
    this.props.onChange(this.state);
  };

  handleOnBlur = () => {
    this.setState({
      isTouched: true
    });
  };
  handleOnChange = (item: FormField<AllowedDataHndlrItem>) => {
    this.setState(state => {
      const newValue = state.value.slice();
      newValue[item.value.id] = item.value;
      return {
        value: newValue
      };
    }, this.propogateChange);
  };

  removeItem = (e: React.MouseEvent, index: number) => {
    e.preventDefault();
    this.setState(state => {
      const newValue = state.value.slice();
      newValue.splice(index, 1);
      return {
        value: newValue
      };
    }, this.propogateChange);
  };

  addItem = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState(state => {
      const newValue = state.value.slice();
      newValue.push({FieldName: shortuid()});
      return {
        value: newValue
      };
    }, this.propogateChange);
  };
  renderAllowedHandlerItem = (allowedDataHndlr: AllowedDataHandler, index: number) => {
    const { namePlaceholder, organisationPlaceholder, validationResults } = this.props;
    const { length } = this.state.value;
    const value = { ...allowedDataHndlr, id: index };
    return (
      <div className="textinput-item" key={allowedDataHndlr.FieldName}>
        <AllowedDataHandlerItem
          fieldName=""
          organisationPlaceholder={organisationPlaceholder}
          namePlaceholder={namePlaceholder}
          value={value}
          index={index}
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
          validationResults={validationResults}
          hasHitSummary={this.props.hasHitSummary}
        />
        {length > 1 && (
          <div className="textinput-grp__control-row">
            <RemoveItemButton onClick={e => this.removeItem(e, index)} text="Ta bort" />
          </div>
        )}
      </div>
    );
  };
  public render() {
    const { value, isTouched } = this.state;
    const errorMessage = this._errorMessage;
    return (
      <div className="textinput-grp textinput-grp--multi">
        {
          errorMessage && <InputError id="allowedDataHandlersListInputError" errorText={errorMessage} />
        }
        {value.map(this.renderAllowedHandlerItem)}
        {value.length < 15 && (
          <div className="textinput-grp__control-row">
            <AddItemButton onClick={this.addItem} text="Lägg till fler" />
          </div>
        )}
        {value.length >= 15 && 
          <InputInfo infoText={`Du kan som mest ange ${15} personer`} />
        }
      </div>
    );
  }
}
